import { Nullable } from "@/api/ApiClient";

export type ClientFormData = Nullable<{
    id: string | undefined;
    codigo: string,
    nombre: string,
    nombre_comercial: string,
    telefono1_cd: string,
    telefono1: string,
    telefono2_cd: string,
    telefono2: string,
    /** JSON serializado con las opciones de envio: ver `ClientShippingOption[]`. */
    shipping_data: string,
    direccion: string,
    cuentas_bancarias: string,
    contacto: string,
    tipo_identificacion: string,
    identificacion: string,
    email: string,
    tipo: number,
    plazo: number,
    descuento: number,
    tipo_descuento: string,
    einvoice_kind: string,
    with_user_info: boolean,
    active: boolean,
    credit_limit: number,
    activitycode: string,
    tax_regime: string,
    zoneId: string,
    zone: any,
    salemanId: string,
    saleman: any,
    priceId: string,
    price: any,
    recibes: any,
    invoices: any,
    quotes: any[],
    settlements: any[],
    creditnotes: any[],
    debitnotes: any[]
}>;

export const ClientRelatedAttributes: Array<keyof ClientFormData> = ["zone", "saleman", "price", "recibes", "invoices", "quotes", "settlements", "creditnotes", "debitnotes"];